import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useContextOnboarding } from '../../contexts/onboardingContext'
import { FeatureDiscoveryElement } from '../../types/FeatureDiscoveryElement'

const GeneratorTooltip = () => {
  const { t } = useTranslation()
  const { featureDiscoveryElementsOpen, featureDiscoveryElementsAlreadyShown } =
    useContextOnboarding()
  const tooltipRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (featureDiscoveryElementsOpen.includes(FeatureDiscoveryElement.PATTERNLIST)) {
      tooltipRef.current?.classList.add('show')
    } else if (tooltipRef.current?.classList.contains('show')) {
      tooltipRef.current?.classList.add('hide')
    }
  }, [featureDiscoveryElementsOpen, featureDiscoveryElementsAlreadyShown])

  return (
    <div className="absolute right-[calc(100%+10px)] top-1/2 -translate-y-1/2 xs:right-[calc(100%+30px)] lg:right-[calc(100%+40px)] xxl:right-[calc(100%+3vw+30px)]">
      {/* the 'show' and 'hide' classes are toggled through the ref */}
      <div
        ref={tooltipRef}
        className="flex h-[60px] translate-x-[50px] select-none items-center whitespace-nowrap rounded-[60px] bg-black px-[30px] py-0 text-[0.875rem] text-white opacity-0 [transition:all_0.4s_0.6s] tall-xs:h-[70px] tall-xs:px-[40px] xs:tall-sm:px-[40px] sm:h-[90px] sm:text-[1.125rem] md:h-[100px] lg:h-[120px] lg:text-[1.5rem] xxl:h-[136px] xxl:rounded-[80px] xxl:px-[44px] xxl:text-center xxl:text-[26px] [&.hide]:translate-x-0 [&.hide]:animate-[fade-out-x50_0.6s_0s_forwards] [&.hide]:opacity-100 [&.show:not(.hide)]:animate-[fade-in-x50_0.6s_0.6s_forwards]"
      >
        {t('featureDiscovery.choosePatternShort')}
        <img
          className="ml-[1rem] w-[20px] xs:ml-[2.3125rem] xs:w-[22px]"
          src={'/icons/download_icon.svg'}
          alt="arrow-svg"
        />
      </div>
    </div>
  )
}

export default GeneratorTooltip
